import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  transition: none;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: 40px;\n  padding: 0;\n  visibility: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  justify-content: space-between;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { formatDate } from '@scp/ui-shared/core/utils';
import { IconButton } from '@scp/ui-shared/components/buttons';
import { Icon } from '@scp/ui-shared/theme/icons';
import { color, typography } from '@scp/ui-shared/theme/variables';
import { withoutProps } from '@scp/ui-shared/core/hoc';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
var TEXT = {
  PREV_TITLE: 'Previous Month',
  NEXT_TITLE: 'Next Month'
};
var E2E_SUFFIX = '-calendar';
var PROPS_TO_OMIT = ['visible'];
var CommonStyles = "\n  border-bottom: 1px solid ".concat(color.border, ";\n  display: flex;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n");
var Wrapper = styled.div(_templateObject(), color.textBold, typography.fontWeightSemiBold);
var MonthDisplay = styled.div(_templateObject2(), CommonStyles);
var NavigationButton = styled(withoutProps(IconButton, PROPS_TO_OMIT))(_templateObject3(), function (props) {
  return props.visible ? 'visible' : 'hidden';
});
var StyledIcon = styled(Icon)(_templateObject4());
export var CalendarHeader = function CalendarHeader(_ref) {
  var month = _ref.month,
      minMonth = _ref.minMonth,
      maxMonth = _ref.maxMonth,
      onPreviousClick = _ref.onPreviousClick,
      onNextClick = _ref.onNextClick;
  var isMinMonth = !!minMonth && moment(month).isSame(minMonth, 'month');
  var isMaxMonth = !!maxMonth && moment(month).isSame(maxMonth, 'month');
  return React.createElement(Wrapper, null, React.createElement(MonthDisplay, null, React.createElement(NavigationButton, {
    title: TEXT.PREV_TITLE,
    onClick: function onClick() {
      return onPreviousClick();
    },
    visible: !isMinMonth,
    "data-e2e": getE2eLabel(TEXT.PREV_TITLE, E2E_SUFFIX)
  }, React.createElement(StyledIcon, {
    name: "keyboard-arrow-left",
    color: color.action
  })), React.createElement("div", {
    "data-e2e": getE2eLabel(formatDate(month, {
      format: 'monthAndYear'
    }), E2E_SUFFIX)
  }, formatDate(month, {
    format: 'monthAndYear'
  })), React.createElement(NavigationButton, {
    title: TEXT.NEXT_TITLE,
    onClick: function onClick() {
      return onNextClick();
    },
    visible: !isMaxMonth,
    "data-e2e": getE2eLabel(TEXT.NEXT_TITLE, E2E_SUFFIX)
  }, React.createElement(StyledIcon, {
    name: "keyboard-arrow-right",
    color: color.action
  }))));
};